// Third party
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material'
import { FC, useEffect, useState } from 'react'
import { sumBy } from 'lodash'

import RecipientsService from '../../../services/firebase-service/recipients/RecipientsService'

// Types
import Accordion from '../../../components/accordion/common/Accordion'
import { selectExhibitorRefundTotals } from '../../../store/exhibitor/exhibitorSlice'
import { useAppSelector } from '../../../store/hooks'
import ExhibitorProfileRefundAccordion from './accordions/ExhibitorProfileRefundAccordion'
import { convertPrice, getFloatPrice } from '../../../helpers/price'
import { addSalesTax, getCurrency } from '../../../helpers/payment'

import { IEventReviewPublish } from '../../../models/event-review-publish/event-review-publish.interface'

interface ExhibitorProfileRefundTabProps {
  eventData?: IEventReviewPublish | null
  registrarId: string
  eventId: string
}

const ExhibitorProfileRefundTab: FC<ExhibitorProfileRefundTabProps> = ({
  eventData,
  eventId,
  registrarId,
}) => {
  // Hooks and vars
  const refundTotals = useAppSelector(selectExhibitorRefundTotals)
  const chargeSalesTax = eventData?.EventPaymentSettings?.chargeSalesTax

  let refundTotal = 0
  let taxTotal = 0

  const items = [
    ...(refundTotals.eventsRefundPriceTotal || []),
    ...(refundTotals.feesRefundPriceTotal || []),
    ...(refundTotals.ticketsRefundPriceTotal || []),
  ]
  items?.forEach((item) => {
    refundTotal += convertPrice(item.amountRefunded)
    taxTotal += addSalesTax(
      item.created,
      convertPrice(item.amountRefunded),
      item.includeSalesTax,
      chargeSalesTax
    )
  })

  const [isOpen, setIsOpen] = useState(false)
  const [amountPaid, setAmountPaid] = useState(0)

  useEffect(() => {
    const getRecipients = async () => {
      const recipients = await RecipientsService.getByRecipientsByEvent(eventId, registrarId)
      setAmountPaid(sumBy(recipients, (item) => convertPrice(item.amountPaid)))
    }
    if (eventId && registrarId) getRecipients().then()
  }, [registrarId, eventId])

  const currency = getCurrency(eventData?.EventPaymentSettings?.currency)

  return (
    <Accordion
      icon={<AddCircleOutline className="add_icon text-[red]" />}
      initialState={true}
      className="mb-2"
      header={
        <div
          className={`text-SeabiscuitDark200ThemeColor flex justify-between items-center ${isOpen ? 'font-normal' : 'font-bold'}`}
        >
          Refund total
          <div className="flex items-center details">
            <div className="font-normal text-[14px] text-SeabiscuitDark200ThemeColor">
              Refund total: {getFloatPrice(`${currency}${refundTotal / 100}`)}
            </div>
          </div>
        </div>
      }
      headerTextClassName="text-SeabiscuitDark200ThemeColor capitalize w-full pr-2"
      onOpen={() => {
        setIsOpen(true)
      }}
      onClose={() => {
        setIsOpen(false)
      }}
      activeIcon={<RemoveCircleOutline className="add_icon text-[red]" />}
    >
      <div className="faqs-content-inside mt-1">
        <ExhibitorProfileRefundAccordion
          willBeRefund
          total={amountPaid / 100}
          refundTotal={refundTotal / 100}
          taxTotal={taxTotal / 100}
          currency={currency}
        />
      </div>
    </Accordion>
  )
}

export default ExhibitorProfileRefundTab
